import Vue from 'vue'
import Vuex from 'vuex'
import UserService from '../services/UserService'
import Utils from '@/utils/Utils'

import course from './modules/course'
import resource from './modules/resource'
import resources from './modules/resources'
import services from './modules/services'
import service from './modules/service'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    course,
    resource,
    resources,
    services,
    service
  },

  state: {
    isAuthenticated: false,
    user: null,
    userCourses: null,
    showManual: false,
    showOnline: false
  },

  getters: {
    isAuthenticated: state => state.isAuthenticated
  },

  mutations: {
    setIsAuthenticated (state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated
    },

    setUser (state, user) {
      state.user = user
      if (state.user.hasOwnProperty('permissions')) {
        state.showManual = state.user.permissions.includes('user:view:manual') || state.user.permissions.includes('super:all')
        state.showOnline = state.user.permissions.includes('user:view:manual') || state.user.permissions.includes('super:all')
      }
    },

    setUserThumb (state, thumb) {
      state.user = {...state.user, thumb: thumb}
      localStorage.setItem('flUserData', btoa(JSON.stringify(state.user)))
    },

    setUserCourses (state, courses) {
      state.userCourses = courses
    }
  },

  actions: {
    updateUserThumb ({ commit }, { thumb }) {
      return commit('setUserThumb', thumb)
    },
    updateUser ({ commit }, { user }) {
      return commit('setUser', user)
    },

    saveAuthenticatedUser ({ commit }, { user }) {
      commit('setIsAuthenticated', true)
      commit('setUser', user)
      return true
    },

    register ({ commit }, { email, password }) {
      return UserService.register(email, password)
    },

    sendResetPasswordEmail ({ commit }, { email }) {
      return UserService.sendResetPasswordEmail(email)
        .then(res => {
          if (res.data.sent) {
            return true
          }
        })
    },

    resetPassword ({ commit }, { password, passwordConfirm }) {
      return UserService.resetPassword(password, passwordConfirm)
        .then(res => {
          if (res.meta.code === 200) {
            commit('setIsAuthenticated', true)
            commit('setUser', res.data.user)
          }
          return res.data
        })
    },

    validateUser ({ commit }) {
      return UserService.validateUser()
        .then(res => {
          if (res.meta.code === 200) {
            commit('setIsAuthenticated', true)
            commit('setUser', res.data.user)
          }
          return res.data
        })
    },

    authenticate ({ commit }, { provider }) {
      return UserService.authenticate(provider)
        .then(res => {
          commit('setIsAuthenticated', true)
          commit('setUser', JSON.parse(res.user))
          return res
        })
    },

    logout ({ commit }) {
      return UserService.logout()
        .then(res => {
          commit('setIsAuthenticated', false)
          Utils.unsetApiToken()
          return res
        }).catch(err => {
          commit('setIsAuthenticated', false)
          Utils.unsetApiToken()
          return err
        })
    },

    /**
     * Read token and user data from local storage. If they exist, we set the
     * `Authorization: Bearer` token, and trigger the Vuex action that will
     * check if the token is valid and not expired, so we can log the user in
     * automatically
     */
    validateToken ({ commit }) {
      const { apiToken, userData } = Utils.getApiToken()

      if (!apiToken || !userData) return false

      Utils.setApiToken(apiToken, userData)
      const authenticated = UserService.validateToken(apiToken)
      if (authenticated) {
        commit('setIsAuthenticated', authenticated)
        commit('setUser', userData)
        return authenticated
      }
    },

    getUserCourses ({ commit }) {
      return UserService.getUserCourses()
        .then(courses => {
          commit('setUserCourses', courses)
          return courses
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js